module.exports = __webpack_public_path__ + "assets/img/W1-1-F.8e295991.png";